import { c as _c } from "react/compiler-runtime";
import { IoInformationCircleOutline } from "react-icons/io5";
import { Tooltip } from "@/components/ui";
import { cx } from "@/lib/tailwind-utils";
interface InfoButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  showTooltip?: boolean;
  fadeOnHover?: boolean;
  className?: string;
}
export const InfoButton = t0 => {
  const $ = _c(10);
  const {
    onClick,
    showTooltip,
    fadeOnHover,
    className
  } = t0;
  const t1 = fadeOnHover && "opacity-0 group-hover:opacity-100";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cx("inline-flex items-center gap-1 text-caption-strong transition-all duration-200", "text-foreground-muted hover:text-primary", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IoInformationCircleOutline className="w-4 h-4" />;
    t4 = <span>Details</span>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onClick || $[6] !== t2) {
    t5 = <button type="button" onClick={onClick} className={t2}>{t3}{t4}</button>;
    $[5] = onClick;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const button = t5;
  if (showTooltip) {
    let t6;
    if ($[8] !== button) {
      t6 = <Tooltip content="View full details" triggerAsChild={true}>{button}</Tooltip>;
      $[8] = button;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  return button;
};